import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { MapPin, ArrowUpRight, TrendingUp, BedDouble, Bath } from "lucide-react";

export default function ApartmentCard({ apartment, index = 0 }) {
  const uplift = apartment.outcome_metrics?.find((m) =>
    /yield|uplift|adr|occupancy/i.test(m.label),
  );

  return (
    <motion.article
      data-testid={`apartment-card-${apartment.id}`}
      initial={{ opacity: 0, y: 30 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-80px" }}
      transition={{ duration: 0.7, delay: index * 0.08, ease: [0.22, 1, 0.36, 1] }}
      className="card-luxe group flex h-full flex-col overflow-hidden"
    >
      <Link
        to={`/portfolio/${apartment.id}`}
        className="relative block aspect-[4/3] overflow-hidden bg-[#F7F4ED]"
        data-testid={`apartment-card-image-link-${apartment.id}`}
      >
        <img
          src={apartment.images[0]}
          alt={apartment.name}
          loading="lazy"
          className="h-full w-full object-cover transition-transform duration-[1400ms] ease-[cubic-bezier(0.22,1,0.36,1)] group-hover:scale-[1.06]"
        />
        <div className="absolute left-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-white/90 px-3 py-1.5 text-[10px] font-medium uppercase tracking-[0.18em] text-[#967A45] backdrop-blur-md">
          <span className="h-1 w-1 rounded-full bg-[#C6A66B]" />
          {apartment.city}
        </div>
        {uplift && (
          <div className="absolute right-4 top-4 inline-flex items-center gap-1.5 rounded-full bg-[#7A8C7B] px-3 py-1.5 text-[10px] font-medium uppercase tracking-[0.18em] text-white shadow-sm">
            <TrendingUp size={11} /> {uplift.value} {uplift.label.split(" ")[0]}
          </div>
        )}
      </Link>

      <div className="flex flex-1 flex-col p-7">
        <div className="mb-2 inline-flex items-center gap-2 text-[10px] uppercase tracking-[0.22em] text-[#C6A66B]">
          Case Study · Managed Property
        </div>
        <h3 className="font-[Cormorant_Garamond] text-2xl text-[#1A1D1A]">
          {apartment.name}
        </h3>
        <p className="mt-1 inline-flex items-center gap-1.5 text-xs tracking-wide text-[#7A8C7B]">
          <MapPin size={12} className="text-[#C6A66B]" />
          {apartment.address}
        </p>

        <p className="mt-4 line-clamp-3 text-sm leading-relaxed text-[#4A524C]">
          {apartment.short_description}
        </p>

        <div className="my-5 h-px w-full bg-[#C6A66B]/20" />

        <div className="flex items-center gap-5 text-xs text-[#4A524C]">
          <span className="inline-flex items-center gap-1.5">
            <BedDouble size={14} className="text-[#7A8C7B]" />
            {apartment.bedrooms} Bed
          </span>
          <span className="inline-flex items-center gap-1.5">
            <Bath size={14} className="text-[#7A8C7B]" />
            {apartment.bathrooms} Bath
          </span>
          <span className="inline-flex items-center gap-1.5 text-[#967A45]">
            <TrendingUp size={14} />
            {uplift ? uplift.value : "Managed"}
          </span>
        </div>

        <Link
          to={`/portfolio/${apartment.id}`}
          data-testid={`apartment-card-cta-${apartment.id}`}
          className="mt-7 inline-flex items-center justify-between gap-2 rounded-full border border-[#D9CFC2] bg-white px-5 py-3 text-sm font-medium text-[#1A1D1A] transition-all duration-300 hover:border-[#C6A66B] hover:text-[#967A45]"
        >
          Read Case Study
          <ArrowUpRight
            size={16}
            className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5"
          />
        </Link>
      </div>
    </motion.article>
  );
}
